onReady(($) => {
    const videoStoryModules = $('.video-story-module');

    if (videoStoryModules.length === 0) {
        return;
    }

    // Setup video selection click interactions
    videoStoryModules.each((i, videoStoryModule) => {
        $('.profile-frame:first-child', videoStoryModule)
            .addClass('active');
        $('.profile-frame', videoStoryModule)
            .each((i, profileFrame) => {
                profileFrame.addEventListener('click', () => {
                    $('.profile-frame', videoStoryModule)
                        .removeClass('active');
                    $(profileFrame)
                        .addClass('active');
                    $('.wistia-video', videoStoryModule)
                        .hide();
                    $(`.${profileFrame.dataset.videoId}`, videoStoryModule)
                        .show();
                });
            });
    });

    const loadVideos = () => {
        $(window)
            .off('scroll', loadVideos)
        $('.video-story-module .profile-frame')
            .each((i, frame) => loadWistiaMedia(frame.dataset.videoId))
        loadWistiaLibrary()
    }

    $(window)
        .on('scroll', loadVideos);

    // Load if user has already scrolled
    if (window.scrollY > 0) {
        loadVideos()
    }
});
